export default __webpack_public_path__ + "static/media/carousel2.9b5405c1.jpg";